import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const resortFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      title: "Location",
      isHide: isMobileVersion,
      isLocation: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_STATUS,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Status",
      isHide: true,
      detailList: [
        {
          id: 1,
          label: "Open",
          tagId: 1,
        },
        {
          id: 2,
          label: "Closed",
          tagId: 2,
        },
        {
          id: 3,
          label: "Temporarily Closed",
          tagId: 4,
        },
        {
          id: 4,
          label: "Permanently Closed",
          tagId: 3,
        },
      ],
      selectedList: [1, 2, 4],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RESORT_CATEGORY,
      icon: Images.iconTagEventType,
      width: 20,
      height: 20,
      title: "Category",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Basic",
          tagId: 6501,
        },
        {
          id: 2,
          label: "Premium",
          tagId: 6502,
        },
        {
          id: 3,
          label: "Luxury",
          tagId: 6503,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RESORT_PRICE,
      icon: Images.iconTagPrice,
      width: 20,
      height: 20,
      title: "Price",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "$",
          tagId: 6701,
        },
        {
          id: 2,
          label: "$$",
          tagId: 6702,
        },
        {
          id: 3,
          label: "$$$",
          tagId: 6703,
        },
        {
          id: 4,
          label: "$$$$",
          tagId: 6704,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RESORT_FEATURE,
      icon: Images.iconTagFeature,
      width: 20,
      height: 20,
      title: "Features",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Spa",
          tagId: 6601,
        },
        {
          id: 2,
          label: "Ski",
          tagId: 6602,
        },
        {
          id: 3,
          label: "Beach",
          tagId: 6603,
        },
        {
          id: 4,
          label: "Golf",
          tagId: 6604,
        },
        {
          id: 6,
          label: "Amusement Park",
          tagId: 6606,
        },
        {
          id: 7,
          label: "Casino",
          tagId: 6607,
        },
        {
          id: 8,
          label: "Island",
          tagId: 6608,
        },
        {
          id: 9,
          label: "Lake",
          tagId: 6609,
        },
        {
          id: 10,
          label: "Unique location",
          tagId: 6610,
        },
        {
          id: 11,
          label: "Sport",
          tagId: 6611,
        },
        {
          id: 12,
          label: "Historic",
          tagId: 6612,
        },
        {
          id: 13,
          label: "Ranch",
          tagId: 6613,
        },
        {
          id: 14,
          label: "Adult-Only",
          tagId: 6614,
        },
        {
          id: 15,
          label: "Nudist",
          tagId: 6615,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_STAR,
      icon: Images.iconTagStar,
      width: 20,
      height: 20,
      title: "Stars",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "1",
          tagId: 7101,
        },
        {
          id: 2,
          label: "2",
          tagId: 7102,
        },
        {
          id: 3,
          label: "3",
          tagId: 7103,
        },
        {
          id: 4,
          label: "4",
          tagId: 7104,
        },
        {
          id: 5,
          label: "5",
          tagId: 7105,
        },
        {
          id: 6,
          label: "N/A",
          tagId: 7106,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RATING,
      icon: Images.iconTagRating,
      width: 21.5,
      height: isMobileVersion ? 21 : 20,
      title: "Rating",
      isHide: true,
      isRating: true,
      detailList: [
        {
          id: 1,
          label: "1",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating1}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating2}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating3}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating4}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 5,
          label: "5",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating5}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
      ],
      selectedList: [],
    },
  ];
};
